type Mode = 'sandbox' | 'production';

const MODE: Mode = (process.env.REACT_APP_MODE as Mode) || 'sandbox';

const CONFIG: Record<Mode, { API_URL: string; SOCKET_URL: string }> = {
    sandbox: {
        API_URL: 'https://stg-api.nairanbenri.com:3001/api/v1',
        SOCKET_URL: 'https://stg-api.nairanbenri.com:3001',
    },
    production: {
        API_URL: 'https://api.nairanbenri.com:3001/api/v1',
        SOCKET_URL: 'https://api.nairanbenri.com:3001',
    },
};

export const API_URL = CONFIG[MODE].API_URL;
export const SOCKET_URL = CONFIG[MODE].SOCKET_URL;
export const SOCKET_PATH = '/api/v1/socket';
export const WEB_NAME = 'GuardLock';
